import { CreditCard } from "@/api/credit-cards/credit-cards";
import React from "react";
import { cn } from "../../../../../lib/utils";
import { cardTypeConfig } from "./cardTypeConfig";

type Props = {
	card: CreditCard;
};

const GreenCard: React.FC<Props> = (props) => {
	const {
		card: { last4, card_holder, card_type },
	} = props;

	const config = cardTypeConfig[card_type];
	const { Icon, bg } = config;
	return (
		<div
			className={cn(
				"relative   rounded-2xl pt-[15px] pl-6 pr-4 text-white h-[191px] w-full slick-card-wrapper transition-all duration-300 ease-in-out transform",
				bg,
			)}
		>
			<div className="flex justify-between">
				<Icon />
			</div>
			<div className="absolute right-0 bottom-0 bg-white/20 rounded-b-2xl px-2 py-1 w-full h-[47px] transition-all duration-300">
				<div className="flex justify-between items-center pl-[23px] pr-[19px] h-full">
					<p className="text-sm font-bold">{card_holder}</p>
					<p className="text-sm font-bold">*{last4}</p>
				</div>
			</div>
		</div>
	);
};

export default GreenCard;
